document.addEventListener("DOMContentLoaded", function () {
  const meganavCollectionSliders = document.querySelectorAll(
    ".meganav__collection-slider"
  );
  if (meganavCollectionSliders) {
    meganavCollectionSliders.forEach((slider) => {
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
        },
        pagination: {
          el: ".meganav__collection-slider-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next--meganav",
          prevEl: ".swiper-button-prev--meganav",
        },
      });
    });
  }
});
